<template>
  <div class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          :color="message.type === 'error' ? 'red' : 'green'">
          <span
            class="body-1 font-weight-light white--text"
            v-html="message.text">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- Filter Dialog -->
        <v-dialog
          v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          max-width="900"
          persistent
          scrollable>
          <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 popup-header">
              <div class="subtitle-1 font-weight-bold">
                Filter Data Tenant
              </div>

              <v-spacer />

              <v-icon
                @click="dialog.fullscreen = !dialog.fullscreen"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider style="border-top: 2px dashed #EBEBEB;" />

            <v-card-text class="py-4">
              <div class="filter-section-title mb-3" :style="`color: ${set_color};`">
                Data Pribadi
              </div>

              <v-row dense>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">Nama</div>
                  <v-text-field
                    v-model="tempFilters.name"
                    placeholder="Cari nama..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">NIK</div>
                  <v-text-field
                    v-model="tempFilters.nik"
                    placeholder="Cari NIK..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">Kode Unik Penghuni</div>
                  <v-text-field
                    v-model="tempFilters.code"
                    placeholder="Cari kode unik penghuni..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">Email</div>
                  <v-text-field
                    v-model="tempFilters.email"
                    placeholder="Cari email..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">No Handphone</div>
                  <v-text-field
                    v-model="tempFilters.mobilephone"
                    placeholder="Cari no handphone..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">Jenis Kelamin</div>
                  <v-select
                    v-model="tempFilters.gender"
                    :items="genderOptions"
                    item-text="label"
                    item-value="value"
                    placeholder="Pilih jenis kelamin..."
                    dense
                    outlined
                    hide-details
                    clearable
                    class="fs-12" />
                </v-col>
              </v-row>

              <div class="filter-section-title mb-3 mt-4" :style="`color: ${set_color};`">
                Data Unit
              </div>

              <v-row dense>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">No Unit</div>
                  <v-text-field
                    v-model="tempFilters.unit_number"
                    placeholder="Cari no unit..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">Program / Golongan</div>
                  <v-select
                    v-model="tempFilters.category_title"
                    :items="categoryOptions"
                    item-text="label"
                    item-value="value"
                    placeholder="Pilih program / golongan..."
                    dense
                    outlined
                    hide-details
                    clearable
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">Tipe Unit</div>
                  <v-text-field
                    v-model="tempFilters.unit_type"
                    placeholder="Cari tipe unit..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
              </v-row>

              <div class="filter-section-title mb-3 mt-4" :style="`color: ${set_color};`">
                Data Keuangan & Pembayaran
              </div>

              <v-row dense>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">No VA Sewa Unit</div>
                  <v-text-field
                    v-model="tempFilters.va_sewa"
                    placeholder="Cari no VA sewa unit..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">No VA Air</div>
                  <v-text-field
                    v-model="tempFilters.va_air"
                    placeholder="Cari no VA air..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="body-2 mb-1 grey--text text--darken-1">No Perjanjian / Kontrak</div>
                  <v-text-field
                    v-model="tempFilters.last_perjanjian_number"
                    placeholder="Cari no perjanjian / kontrak..."
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
              </v-row>

              <div class="filter-section-title mb-3 mt-4" :style="`color: ${set_color};`">
                Filter Range Tanggal Kontrak
              </div>

              <v-radio-group
                v-model="tempFilters.is_end_kontrak_date"
                row
                hide-details
                class="mt-0 mb-2">
                <v-radio
                  label="Tanggal Mulai Kontrak"
                  :value="false"
                  :color="set_color" />
                <v-radio
                  label="Tanggal Akhir Kontrak"
                  :value="true"
                  :color="set_color" />
              </v-radio-group>

              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="body-2 mb-1 grey--text text--darken-1">Dari Tanggal</div>
                  <v-text-field
                    v-model="tempFilters.tgl_mulai"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="body-2 mb-1 grey--text text--darken-1">Sampai Tanggal</div>
                  <v-text-field
                    v-model="tempFilters.tgl_akhir"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="fs-12" />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider style="border-top: 2px dashed #EBEBEB;" />

            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn
                outlined
                color="red"
                class="text-capitalize mr-2"
                @click="dialog.filter = false">
                Batal
              </v-btn>
              <v-btn
                outlined
                color="orange darken-2"
                class="text-capitalize mr-2"
                @click="resetFilters">
                Reset Filter
              </v-btn>
              <v-btn
                :color="set_color"
                elevation="0"
                class="white--text text-capitalize"
                @click="applyFilters">
                Terapkan Filter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <!-- Header -->
          <v-row class="pa-4 pb-0 pt-0">
            <v-col cols="12" class="pb-1">
              <v-card flat color="transparent">
                <div class="d-flex align-center">
                  <v-avatar
                    tile
                    size="40"
                    :color="set_color_rgb_down"
                    class="mr-3 hidden-sm-and-down">
                    <v-icon :color="set_color">mdi-home-account</v-icon>
                  </v-avatar>

                  <div>
                    <div class="fs-16 black--text" style="font-weight: 600;">
                      Data Penghuni
                    </div>
                    <div class="fs-11 grey--text text--darken-1">
                      Data penghuni berisi daftar dan informasi dasar penghuni yang sudah mendapatkan unit.
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Search & Actions -->
          <v-row justify="start" class="pa-4 py-0 pr-1">
            <v-col cols="12" class="d-flex flex-wrap align-center pb-1">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"
                filled
                rounded
                dense
                single-line
                hide-details
                :color="set_color"
                placeholder="Cari Data . . ."
                append-icon="mdi-magnify"
                clearable
                v-model="search"
                class="fs-12 little-placeholder mr-3"
                style="border-radius: 6px; background: #f6f6f6 !important; max-width: 320px">
              </v-text-field>

              <v-btn
                :color="set_color"
                elevation="0"
                small
                min-height="34"
                class="white--text text-capitalize mr-2"
                style="border-radius: 6px;"
                @click="openFilterDialog">
                <v-icon size="16" class="mr-1">mdi-filter-variant</v-icon>
                Filter
              </v-btn>

              <v-btn
                outlined
                small
                min-height="34"
                color="red"
                class="text-capitalize mr-2"
                style="border-radius: 6px;"
                :loading="process.exportPdf"
                @click="exportPdf">
                <v-icon size="16" class="mr-1">mdi-file-pdf-box</v-icon>
                Export PDF
              </v-btn>

              <v-btn
                outlined
                small
                min-height="34"
                :color="set_color"
                class="text-capitalize"
                style="border-radius: 6px;"
                :loading="process.exportExcel"
                @click="exportExcel">
                <v-icon size="16" class="mr-1">mdi-download</v-icon>
                Export Excel
              </v-btn>
            </v-col>
          </v-row>

          <!-- Active Filters -->
          <v-row v-if="activeFilterChips.length > 0" class="pa-4 py-0">
            <v-col cols="12" class="d-flex flex-wrap align-center">
              <span class="fs-12 font-weight-bold grey--text text--darken-1 mr-2">
                Filter Aktif:
              </span>
              <v-chip
                v-for="chip in activeFilterChips"
                :key="chip.key"
                small
                close
                class="mr-2 mb-1"
                :color="set_color_rgb_down"
                :text-color="set_color"
                @click:close="removeFilter(chip.key)">
                {{ chip.label }}: {{ chip.value }}
              </v-chip>
              <v-chip
                small
                class="mb-1"
                color="red lighten-5"
                text-color="red darken-2"
                @click="resetFilters">
                Hapus Semua Filter
              </v-chip>
            </v-col>
          </v-row>

          <!-- Table -->
          <v-row class="pa-4 py-0">
            <v-col cols="12" class="py-0">
              <v-card flat style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          class="sticky-col one-col"
                          style="z-index: 2; font-size: 12px; border: 1px solid #ededed; width: 100px; min-width: 100px; padding: 8px 12px; text-align: center;">
                          Aksi
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          class="sticky-col two-col"
                          style="z-index: 2; font-size: 12px; border: 1px solid #ededed; width: 150px; min-width: 150px; padding: 8px 12px; text-align: left; cursor: pointer;"
                          @click="toggleSort('name')">
                          Nama Penghuni
                          <v-icon v-if="sortBy === 'name'" color="white" size="14">
                            {{ sortDesc ? 'mdi-arrow-down-thin' : 'mdi-arrow-up-thin' }}
                          </v-icon>
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap; cursor: pointer;"
                          @click="toggleSort('last_perjanjian_number')">
                          Nomor Perjanjian / Kontrak
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Kode Unik Penghuni
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          No Unit
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Program / Golongan
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Email
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          No Handphone
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Jenis Kelamin
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          NIK
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Va Sewa Unit
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Va Air
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          Input Oleh
                        </th>
                      </tr>

                      <tr
                        v-for="(item, index) in list"
                        :key="item.id"
                        @click="selectedRow = index"
                        :class="selectedRow === index ? 'selected' : ''">
                        <td
                          class="sticky-col one-col"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 4px; text-align: center;">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text mx-1 px-0"
                                @click.stop="viewDetail(item)">
                                <v-icon size="14">mdi-eye-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Detail</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="blue darken-1"
                                elevation="0"
                                class="white--text mx-1 px-0"
                                @click.stop="editDetail(item)">
                                <v-icon size="14">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Ubah</span>
                          </v-tooltip>
                        </td>
                        <td
                          class="sticky-col two-col"
                          style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; font-weight: 700; color: #0084d1;">
                          {{ item.name }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.last_perjanjian_number || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.code }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.unit_number }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap; text-transform: capitalize;">
                          {{ item.category_title }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.email }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.mobilephone }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.gender }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.nik }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.va_sewa || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.va_air || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; white-space: nowrap;">
                          {{ item.registered_input_user_name }}
                        </td>
                      </tr>
                    </table>
                  </div>

                  <v-card-text
                    v-if="process.load"
                    class="pb-0 my-4"
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">Mohon Tunggu . . .</div>
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10" />
                    </div>
                  </v-card-text>

                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4"
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img
                        class="mx-auto"
                        contain
                        alt="empty"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')" />
                      <div class="mt-3 fs-16">Belum Ada Data</div>
                    </div>
                  </v-card-text>

                  <pagination
                    v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)"
                    @reloadPage="fetch($event)"
                    :model="pagination"
                    :display="paginationList" />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/id'

const DUMMY_TENANTS = [
  {
    id: 1,
    name: 'Budi Santoso',
    code: 'TNT-2024-001',
    last_perjanjian_number: 'PKS/001/2024',
    unit_number: '1A-0401',
    category_title: 'MBR',
    email: 'budi.santoso@email.com',
    mobilephone: '081234567890',
    gender: 'Laki-laki',
    nik: '3374010101010001',
    va_sewa: '880012345678901',
    va_air: '880098765432109',
    unit_type: '2BR',
    unit_water_meter: 'WM-1A-0401',
    registered_input_user_name: 'Admin Rusunawa',
    submission_start_date: '2024-01-15',
    submission_end_date: '2026-01-14',
    address: 'Jl. Merdeka No. 10, Semarang'
  },
  {
    id: 2,
    name: 'Siti Aminah',
    code: 'TNT-2024-002',
    last_perjanjian_number: 'PKS/002/2024',
    unit_number: '1B-0512',
    category_title: 'Non-MBR',
    email: 'siti.aminah@email.com',
    mobilephone: '081298765432',
    gender: 'Perempuan',
    nik: '3374020202020002',
    va_sewa: '880012345678902',
    va_air: '880098765432110',
    unit_type: '1BR',
    unit_water_meter: 'WM-1B-0512',
    registered_input_user_name: 'Admin Rusunawa',
    submission_start_date: '2024-02-01',
    submission_end_date: '2026-01-31',
    address: 'Jl. Diponegoro No. 25, Semarang'
  },
  {
    id: 3,
    name: 'Ahmad Wijaya',
    code: 'TNT-2024-003',
    last_perjanjian_number: 'PKS/003/2024',
    unit_number: '2A-0305',
    category_title: 'MBR',
    email: 'ahmad.wijaya@email.com',
    mobilephone: '081345678901',
    gender: 'Laki-laki',
    nik: '3374030303030003',
    va_sewa: '880012345678903',
    va_air: '880098765432111',
    unit_type: '2BR',
    unit_water_meter: null,
    registered_input_user_name: 'Operator 1',
    submission_start_date: '2024-03-10',
    submission_end_date: '2026-03-09',
    address: 'Jl. Gajah Mada No. 5, Semarang'
  },
  {
    id: 4,
    name: 'Dewi Lestari',
    code: 'TNT-2024-004',
    last_perjanjian_number: 'PKS/004/2024',
    unit_number: '2B-0610',
    category_title: 'Non-MBR',
    email: 'dewi.lestari@email.com',
    mobilephone: '081456789012',
    gender: 'Perempuan',
    nik: '3374040404040004',
    va_sewa: '880012345678904',
    va_air: '880098765432112',
    unit_type: '3BR',
    unit_water_meter: 'WM-2B-0610',
    registered_input_user_name: 'Operator 2',
    submission_start_date: '2024-04-20',
    submission_end_date: '2026-04-19',
    address: 'Jl. Pandanaran No. 88, Semarang'
  },
  {
    id: 5,
    name: 'Rudi Hartono',
    code: 'TNT-2024-005',
    last_perjanjian_number: 'PKS/005/2024',
    unit_number: '3A-0208',
    category_title: 'MBR',
    email: 'rudi.hartono@email.com',
    mobilephone: '081567890123',
    gender: 'Laki-laki',
    nik: '3374050505050005',
    va_sewa: '880012345678905',
    va_air: '880098765432113',
    unit_type: '1BR',
    unit_water_meter: 'WM-3A-0208',
    registered_input_user_name: 'Admin Rusunawa',
    submission_start_date: '2024-05-05',
    submission_end_date: '2026-05-04',
    address: 'Jl. Pemuda No. 12, Semarang'
  },
  {
    id: 6,
    name: 'Maya Sari',
    code: 'TNT-2024-006',
    last_perjanjian_number: 'PKS/006/2024',
    unit_number: '3B-0715',
    category_title: 'Non-MBR',
    email: 'maya.sari@email.com',
    mobilephone: '081678901234',
    gender: 'Perempuan',
    nik: '3374060606060006',
    va_sewa: '880012345678906',
    va_air: '880098765432114',
    unit_type: '2BR',
    unit_water_meter: 'WM-3B-0715',
    registered_input_user_name: 'Operator 1',
    submission_start_date: '2024-06-15',
    submission_end_date: '2026-06-14',
    address: 'Jl. Simpang Lima No. 3, Semarang'
  },
  {
    id: 7,
    name: 'Eko Prasetyo',
    code: 'TNT-2024-007',
    last_perjanjian_number: 'PKS/007/2024',
    unit_number: '1A-0811',
    category_title: 'MBR',
    email: 'eko.prasetyo@email.com',
    mobilephone: '081789012345',
    gender: 'Laki-laki',
    nik: '3374070707070007',
    va_sewa: '880012345678907',
    va_air: '880098765432115',
    unit_type: '2BR',
    unit_water_meter: 'WM-1A-0811',
    registered_input_user_name: 'Admin Rusunawa',
    submission_start_date: '2024-07-01',
    submission_end_date: '2026-06-30',
    address: 'Jl. Kaligawe No. 45, Semarang'
  },
  {
    id: 8,
    name: 'Fitri Handayani',
    code: 'TNT-2024-008',
    last_perjanjian_number: 'PKS/008/2024',
    unit_number: '2A-0918',
    category_title: 'Non-MBR',
    email: 'fitri.handayani@email.com',
    mobilephone: '081890123456',
    gender: 'Perempuan',
    nik: '3374080808080008',
    va_sewa: '880012345678908',
    va_air: '880098765432116',
    unit_type: '1BR',
    unit_water_meter: null,
    registered_input_user_name: 'Operator 2',
    submission_start_date: '2024-08-10',
    submission_end_date: '2026-08-09',
    address: 'Jl. Setiabudi No. 7, Semarang'
  }
]

const FILTER_LABELS = {
  name: 'Nama',
  email: 'Email',
  mobilephone: 'No Handphone',
  nik: 'NIK',
  code: 'Kode Unik Penghuni',
  gender: 'Jenis Kelamin',
  category_title: 'Program / Golongan',
  unit_number: 'No Unit',
  last_perjanjian_number: 'No Perjanjian / Kontrak',
  unit_type: 'Tipe Unit',
  va_sewa: 'No VA Sewa Unit',
  va_air: 'No VA Air'
}

const EMPTY_TEMP_FILTERS = () => ({
  name: '',
  email: '',
  mobilephone: '',
  nik: '',
  code: '',
  gender: null,
  category_title: null,
  unit_number: '',
  last_perjanjian_number: '',
  unit_type: '',
  va_sewa: '',
  va_air: '',
  tgl_mulai: '',
  tgl_akhir: '',
  is_end_kontrak_date: false
})

export default {
  components: {
    pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue')
  },
  data () {
    return {
      dialog: {
        snackbar: false,
        filter: false,
        fullscreen: false
      },
      message: {
        text: '',
        type: 'success'
      },
      search: '',
      filters: {},
      tempFilters: EMPTY_TEMP_FILTERS(),
      list: [],
      pagination: {},
      paginationList: {
        row: 50,
        page: 1
      },
      sortBy: 'id',
      sortDesc: true,
      selectedRow: null,
      process: {
        load: false,
        exportPdf: false,
        exportExcel: false
      },
      genderOptions: [
        { label: 'Laki-laki', value: 'Laki-laki' },
        { label: 'Perempuan', value: 'Perempuan' }
      ],
      categoryOptions: [
        { label: 'MBR', value: 'MBR' },
        { label: 'Non-MBR', value: 'Non-MBR' }
      ]
    }
  },
  computed: {
    set_color () {
      return this.$store.state.color
    },
    set_color_rgb_down () {
      const [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
      return `rgba(${r}, ${g}, ${b}, 0.15)`
    },
    activeFilterChips () {
      const chips = []

      Object.keys(FILTER_LABELS).forEach((key) => {
        if (this.filters[key]) {
          chips.push({
            key,
            label: FILTER_LABELS[key],
            value: this.filters[key]
          })
        }
      })

      if (this.filters.tgl_mulai || this.filters.tgl_akhir) {
        const dateLabel = this.filters.is_end_kontrak_date
          ? 'Tanggal Akhir Kontrak'
          : 'Tanggal Mulai Kontrak'
        const tglMulai = this.filters.tgl_mulai
          ? moment(this.filters.tgl_mulai).format('DD MMMM YYYY')
          : '...'
        const tglAkhir = this.filters.tgl_akhir
          ? moment(this.filters.tgl_akhir).format('DD MMMM YYYY')
          : '...'

        chips.push({
          key: 'date_range',
          label: dateLabel,
          value: `${tglMulai} - ${tglAkhir}`
        })
      }

      return chips
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    notify (text, type = 'success') {
      this.message.text = text
      this.message.type = type
      this.dialog.snackbar = true
    },

    openFilterDialog () {
      this.tempFilters = {
        ...EMPTY_TEMP_FILTERS(),
        name: this.filters.name || '',
        email: this.filters.email || '',
        mobilephone: this.filters.mobilephone || '',
        nik: this.filters.nik || '',
        code: this.filters.code || '',
        gender: this.filters.gender || null,
        category_title: this.filters.category_title || null,
        unit_number: this.filters.unit_number || '',
        last_perjanjian_number: this.filters.last_perjanjian_number || '',
        unit_type: this.filters.unit_type || '',
        va_sewa: this.filters.va_sewa || '',
        va_air: this.filters.va_air || '',
        tgl_mulai: this.filters.tgl_mulai || '',
        tgl_akhir: this.filters.tgl_akhir || '',
        is_end_kontrak_date: this.filters.is_end_kontrak_date || false
      }
      this.dialog.filter = true
    },

    applyFilters () {
      const newFilters = {}

      Object.keys(FILTER_LABELS).forEach((key) => {
        if (this.tempFilters[key]) {
          newFilters[key] = this.tempFilters[key]
        }
      })

      if (this.tempFilters.tgl_mulai) {
        newFilters.tgl_mulai = this.tempFilters.tgl_mulai
      }
      if (this.tempFilters.tgl_akhir) {
        newFilters.tgl_akhir = this.tempFilters.tgl_akhir
      } else if (this.tempFilters.tgl_mulai) {
        newFilters.tgl_akhir = moment().format('YYYY-MM-DD')
      }
      if (this.tempFilters.tgl_mulai || this.tempFilters.tgl_akhir) {
        newFilters.is_end_kontrak_date = this.tempFilters.is_end_kontrak_date
      }

      this.filters = newFilters
      this.dialog.filter = false
      this.fetch({ row: this.paginationList.row, page: 1 })
    },

    resetFilters () {
      this.tempFilters = EMPTY_TEMP_FILTERS()
      this.filters = {}
      this.dialog.filter = false
      this.fetch({ row: this.paginationList.row, page: 1 })
    },

    removeFilter (key) {
      if (key === 'date_range') {
        const newFilters = { ...this.filters }
        delete newFilters.tgl_mulai
        delete newFilters.tgl_akhir
        delete newFilters.is_end_kontrak_date
        this.filters = newFilters
      } else {
        const newFilters = { ...this.filters }
        delete newFilters[key]
        this.filters = newFilters
      }
      this.fetch({ row: this.paginationList.row, page: 1 })
    },

    toggleSort (field) {
      if (this.sortBy === field) {
        this.sortDesc = !this.sortDesc
      } else {
        this.sortBy = field
        this.sortDesc = false
      }
      this.fetch()
    },

    filterDummyData () {
      let data = [...DUMMY_TENANTS]
      const keyword = (this.search || '').toLowerCase().trim()

      if (keyword) {
        data = data.filter((item) => {
          const haystack = [
            item.name,
            item.code,
            item.email,
            item.mobilephone,
            item.nik,
            item.unit_number,
            item.category_title,
            item.last_perjanjian_number,
            item.va_sewa,
            item.va_air,
            item.registered_input_user_name
          ].join(' ').toLowerCase()

          return haystack.includes(keyword)
        })
      }

      Object.keys(this.filters).forEach((key) => {
        const value = this.filters[key]
        if (!value || ['tgl_mulai', 'tgl_akhir', 'is_end_kontrak_date'].includes(key)) {
          return
        }

        data = data.filter((item) => {
          const fieldValue = String(item[key] || '').toLowerCase()
          return fieldValue.includes(String(value).toLowerCase())
        })
      })

      if (this.filters.tgl_mulai || this.filters.tgl_akhir) {
        const dateField = this.filters.is_end_kontrak_date
          ? 'submission_end_date'
          : 'submission_start_date'
        const start = this.filters.tgl_mulai || '1900-01-01'
        const end = this.filters.tgl_akhir || moment().format('YYYY-MM-DD')

        data = data.filter((item) => {
          const date = item[dateField]
          return date >= start && date <= end
        })
      }

      data.sort((a, b) => {
        const aVal = a[this.sortBy]
        const bVal = b[this.sortBy]

        if (aVal === bVal) return 0
        if (aVal == null) return 1
        if (bVal == null) return -1

        const result = String(aVal).localeCompare(String(bVal), 'id', { numeric: true })
        return this.sortDesc ? -result : result
      })

      return data
    },

    fetch (pagination = { row: 50, page: 1 }) {
      this.process.load = true
      this.paginationList = pagination
      this.selectedRow = null

      setTimeout(() => {
        const filtered = this.filterDummyData()
        const limit = pagination.row
        const page = pagination.page
        const total = filtered.length
        const totalPage = Math.max(1, Math.ceil(total / limit))
        const currentPage = Math.min(page, totalPage)
        const start = (currentPage - 1) * limit

        this.list = filtered.slice(start, start + limit)
        this.pagination = {
          total_data: total,
          total_page: totalPage,
          total_display: this.list.length,
          current: currentPage,
          prev: currentPage > 1 ? currentPage - 1 : 1,
          next: currentPage < totalPage ? currentPage + 1 : totalPage
        }
        this.process.load = false
      }, 300)
    },

    exportPdf () {
      this.process.exportPdf = true
      setTimeout(() => {
        this.process.exportPdf = false
        this.notify('Export PDF dummy — belum terhubung ke API backend.', 'success')
      }, 800)
    },

    exportExcel () {
      this.process.exportExcel = true
      setTimeout(() => {
        this.process.exportExcel = false
        this.notify('Export Excel dummy — belum terhubung ke API backend.', 'success')
      }, 800)
    },

    viewDetail (item) {
      this.$router.push(`/penghuni-rusunawa/detail/${item.id}`)
    },

    editDetail (item) {
      this.notify(`Ubah penghuni dummy: <b>${item.name}</b>`, 'success')
    },

    showQr (item) {
      this.notify(`QR Meteran Air dummy: <b>${item.unit_water_meter}</b> (${item.name})`, 'success')
    }
  }
}
</script>

<style scoped>
.filter-section-title {
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 4px;
}

.wrapper-pegawai {
  overflow-x: auto;
  max-width: 100%;
}

.sticky-col.one-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 1;
}

.sticky-col.two-col {
  position: sticky;
  left: 100px;
  background: #fff;
  z-index: 1;
}

tr.selected td {
  background-color: #f5f9ff !important;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.table th,
.table td {
  background-clip: padding-box;
}
</style>
